import { z } from 'zod';

import type { Mutation } from './common';
import { idSchema } from './id';
import { skillShortSchema } from './skill';

export type SkillIdsField = {
    readonly skillIds?: readonly string[];
};

export const workHistoryItemSchema = z.object({
    id: z.string(),
    companyName: z.string(),
    dateFrom: z.string().optional(),
    dateTo: z.string().optional(),
    department: z.string().optional(),
    description: z.string().optional(),
    jobTitle: z.string(),
    location: z.string().optional(),
    ongoing: z.boolean().optional(),
    skills: skillShortSchema.array().optional(),
});

export const workHistoryItemArraySchema = workHistoryItemSchema.array();

export type WorkHistoryItem = z.infer<typeof workHistoryItemSchema>;

export const workHistoryCreationSchema = workHistoryItemSchema
    .omit({ id: true, skills: true })
    .extend({ skillIds: idSchema.array().optional() });
export type WorkHistoryCreation = z.infer<typeof workHistoryCreationSchema>;
export type WorkHistoryMutation = Mutation<WorkHistoryItem> &
    Pick<WorkHistoryItem, 'companyName' | 'id' | 'jobTitle'> &
    SkillIdsField;
